import { IDesignerTemplateState, IDesignTemplateSearchFilter } from './IDesignerTemplateState';
import { Draft, PayloadAction } from '@reduxjs/toolkit';

export function setFilterReducer(
  state: Draft<IDesignerTemplateState>,
  action: PayloadAction<IDesignTemplateSearchFilter>,
) {
  state.filter = action.payload;
}
